import React from "react";
import { Modal as MuiModal, Box, Slide } from "@mui/material";

function Modal({ open, handleClose, style, children, isFilterModal }) {
  const anchorLeft = style?.left !== undefined && style?.left !== null;
  const slideDirection = style?.slideDirection ?? "left";

  const modalPadding = isFilterModal
    ? "0px 6px 4px 18px" 
    : style?.padding || "22px 22px 22px 22px ";

  const modalStyle = {
    position: "fixed",
    bottom: 0,
    ...(anchorLeft ? { left: style.left, right: style?.right !== undefined ? style.right : "auto" } : { right: style?.right !== undefined ? style.right : 0 }),
    top: style?.top !== undefined ? style.top : "auto",
    width: style?.width || "350px",
    height: style?.height || "auto",
    maxHeight: style?.maxHeight !== undefined ? style.maxHeight : "96vh",
    overflowY: style?.scroll || "auto",
    overflowX: style?.overflowX || "auto",

    "&::-webkit-scrollbar": {
      width: "0px",
      height: "0px",
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
    },
    boxShadow: style?.boxShadow ? style?.boxShadow : 24,
    p: modalPadding, // Use conditional padding
    m: "auto",
    mb: style?.mb !== undefined ? style.mb : 2,
    mr: style?.mr !== undefined ? style.mr : anchorLeft ? 0 : 3.5,
    ...(style?.ml !== undefined ? { ml: style.ml } : {}),
    boxSizing: style?.boxSizing !== undefined ? style.boxSizing : "content-box",
    bgcolor: "white",
    color: "#00000",
    borderRadius: "5px",
    outline: "none",
    ...(style?.transform != null ? { transform: style.transform } : {}),
  };
  return (
    <MuiModal open={open} onClose={handleClose} BackdropProps={{ style: { backgroundColor: "transparent" } }}>
      <Slide direction={slideDirection} in={open} timeout={500} mountOnEnter unmountOnExit>
        <Box sx={modalStyle}>{children}</Box>
      </Slide>
    </MuiModal>
  );
}

export default Modal;
